const features = [
  {
    icon: '💬',
    title: 'Live Chat',
    desc: 'Real-time conversations with interactive AI cosplay characters — each with unique personalities, backstories, and dynamic responses tailored to your fantasy.',
  },
  {
    icon: '🎨',
    title: 'AI Image Generation',
    desc: 'Create stunning custom cosplay art on demand — powered by custom-trained AI models built exclusively for CosplayFans. Any character, any pose, any style.',
  },
  {
    icon: '👑',
    title: 'VIP Access',
    desc: 'Tiered subscription model with VIP memberships offering exclusive AI characters, premium image generation, and priority features for the ultimate experience.',
  },
]

export default function PlatformOverview() {
  return (
    <section class="cf-section">
      {/* Header — left aligned, max-width 700px */}
      <div class="mb-8 max-w-[700px]">
        <div class="cf-eyebrow pill mb-4 inline-flex">Platform Overview</div>
        <h2 class="cf-h2 mb-3.5">
          THE ULTIMATE{' '}
          <span class="cf-grad-text">AI COSPLAY EXPERIENCE</span>
        </h2>
        <p class="cf-lede">
          A cosplay and AI image generation platform where users interact with digital characters — live chat, create, and collect across hundreds of unique AI-powered cosplay personas.
        </p>
      </div>

      {/* Feature cards */}
      <div class="grid gap-4 sm:grid-cols-3 sm:gap-5">
        {features.map((f) => (
          <div
            class="rounded-2xl p-6"
            style={{
              background: 'rgba(18,14,36,0.95)',
              border: '1.5px solid rgba(130,70,230,0.5)',
              'box-shadow':
                'inset 0 0 40px rgba(138,43,226,0.22), inset 0 0 80px rgba(138,43,226,0.08), 0 0 20px rgba(138,43,226,0.18)',
            }}
          >
            {/* Icon */}
            <div
              class="mb-4 grid h-[52px] w-[52px] place-items-center rounded-[14px] text-[24px]"
              style={{
                background: 'rgba(18,14,36,0.9)',
                border: '1.5px solid rgba(130,70,230,0.55)',
                'box-shadow': 'inset 0 0 20px rgba(138,43,226,0.3), 0 0 16px rgba(138,43,226,0.25)',
              }}
            >
              {f.icon}
            </div>
            {/* Title */}
            <h3 class="mb-2 font-bebas text-[22px] tracking-[1px] text-white">
              {f.title}
            </h3>
            {/* Description */}
            <p class="text-[13.5px] leading-[1.7] text-[var(--cf-muted)]">
              {f.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
